module.exports = __webpack_public_path__ + "img/img-a94acad1.9887a6df.png";